<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="frontmatter">
<header>
<h1 class="FMH"><span aria-label="xi" id="pg_xi" role="doc-pagebreak"><span href="#/xhtml/contents#c_the" id="the" title="Link target outside of Sample"><b>T<span class="small">HE</span> M<span class="small">C</span>B<span class="small">RIDE</span> F<span class="small">AMILY</span> T<span class="small">REE</span></b></span></span></h1>
</header>
<figure class="IMG"><img alt="" class="img90" src="images/pgxi.jpg"/>
</figure>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?71d39857